import { Card } from '@/components/ui/card';
import { highlights } from '../constants';

export function HighlightsSection() {
    return (
        <section id="highlights" className="grid gap-6 md:grid-cols-3">
            {highlights.map((highlight) => {
                const Icon = highlight.icon;
                return (
                    <Card
                        key={highlight.title}
                        className="flex flex-col gap-4 border-slate-200/70 bg-white/80 p-7 text-slate-800 shadow-sm backdrop-blur-sm dark:border-slate-700/60 dark:bg-gray-900/70 dark:text-slate-200"
                    >
                        <span className="inline-flex size-10 items-center justify-center rounded-full bg-slate-900/90 text-white dark:bg-white/15">
                            <Icon className="size-5" />
                        </span>
                        <h3 className="text-lg font-semibold">
                            {highlight.title}
                        </h3>
                        <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-400">
                            {highlight.description}
                        </p>
                    </Card>
                );
            })}
        </section>
    );
}
